import { render, staticRenderFns } from "./LinkHistory.vue?vue&type=template&id=10c4bf67&"
import script from "./LinkHistory.vue?vue&type=script&lang=js&"
export * from "./LinkHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports